const EXT_REGEX = /\.[a-z0-9]+$/i

function FileToVideoMIMEType(filetype) {
  const ext = filetype.match(EXT_REGEX)

  switch(ext) {
    case ".ogg":
      return "video/ogg"
    case ".mp4":
      return "video/mp4"
    case ".webm":
      return "video/webm"
    default:
      return ""
  }
}

function FileToAudioMIMEType(filetype) {
  const ext = filetype.match(EXT_REGEX)

  switch(ext) {
    case ".ogg":
      return "audio/ogg"
    case ".mp3":
      return "audio/mpeg"
    default:
      return ""
  }
}

export { FileToVideoMIMEType, FileToAudioMIMEType }